import React from 'react';
import DOMPurify from 'dompurify';

const BODY_FONT = 'Inter, sans-serif';

/**
 * Text Block Renderer
 * Variants: default, two_column
 */
export default function TextRenderer({ props, variant }) {
  const {
    content = '<p>Start typing your content here...</p>',
    max_width = 'prose',
  } = props;

  const maxWidthClass = max_width === 'prose'
    ? 'max-w-prose'
    : max_width === 'full'
    ? 'max-w-full'
    : max_width === 'lg'
    ? 'max-w-4xl'
    : max_width === 'xl'
    ? 'max-w-6xl'
    : 'max-w-prose';

  if (variant === 'two_column') {
    return (
      <section className="py-12 px-6">
        <div
          className={`${maxWidthClass} mx-auto`}
          style={{ fontFamily: BODY_FONT }}
        >
          <div
            className="prose prose-stone max-w-none columns-1 md:columns-2 gap-8"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
          />
        </div>
      </section>
    );
  }

  // Default variant
  return (
    <section className="py-12 px-6">
      <div
        className={`${maxWidthClass} mx-auto`}
        style={{ fontFamily: BODY_FONT }}
      >
        <div
          className="prose prose-stone max-w-none"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        />
      </div>
    </section>
  );
}
